import { styled } from '@mui/system';
import Button from '@mui/material/Button';
import Pagination from '@mui/material/Pagination';

export const Cnt = styled('div')(({ theme }) => ({
  padding: theme.spacing(1),
  margin: theme.spacing(3, 3, 2, 3),
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(2, 0, 0, 0)
  },
  [theme.breakpoints.down('sm')]: {
    margin: 0
  }
}));

export const AddButtonLabel = styled('span')({
  color: 'rgba(0, 0, 0, 0.87)',
  marginLeft: 4,
  whiteSpace: 'nowrap'
});

export const AddBtn = styled(Button)({
  gridArea: 'addBtn',
  justifySelf: 'end'
});

export const StyledPagination = styled(Pagination)(({ theme }) => ({
  paddingBottom: theme.spacing(3),
  '& > ul': {
    justifyContent: 'center'
  }
}));

export const PaginationPlaceholder = styled('div')({
  height: 1
});

export const MobilePaginationPlaceholder = styled('div')({
  paddingBottom: '80px'
});
